import { BsChevronDown, BsChevronUp } from "react-icons/bs";
import React, { useEffect, useState } from "react";
import "./BackToTop.css";

function BackToTop() {
  const [showBtT, setshowBtT] = useState(false);
  const ScrollToTop = () =>{
    window.scrollTo(0,0)
  }
  const ScrollToBottom = () =>{
    window.scrollTo(0, document.body.scrollHeight);
  }
  useEffect(() => {
    window.addEventListener("scroll", () => {
      let scrolled = window.scrollY;

      if (scrolled > document.body.scrollHeight/2) {
        setshowBtT(true);
      } else {
        setshowBtT(false);
      }
    });
  }, [window.scrollY]);
  return (
    <>
      <div id="navright-backToTop">
        {showBtT ? (
            <BsChevronUp onClick={ScrollToTop} className="backToTop-icon" />
        ) : (
            <BsChevronDown onClick={ScrollToBottom} className="backToBottom-icon" />
        )}
      </div>
    </>
  );
}

export default BackToTop;
